(() => {
	// Matches $bp-lg.
	const DESKTOP = 992;
	const ARROWS_HEIGHT = 40;
	const desktop = window.matchMedia(`(min-width: ${DESKTOP}px)`);
	// Also bundled into the block editor's canvas by editor-post-slider.js.
	const inEditor = Boolean(window.frameElement && window.frameElement.name === 'editor-canvas');

	// The comp's layout: a Columns block with a Section Header in the column
	// before this one. There the arrows go under the intro on desktop; anywhere
	// else they stay under the cards.
	const introColumnFor = (block) => {
		const column = block.closest('.wp-block-column');
		const intro = column && !column.nextElementSibling ? column.previousElementSibling : null;
		return intro && intro.classList.contains('wp-block-column') && intro.querySelector('.block-section-header') ? intro : null;
	};

	// Stacked, the active card is centred with its neighbours peeking either
	// side; beside the intro, the row starts on the track's left edge and runs
	// off the page. Card widths come from CSS.
	const start = (block) => {
		const viewport = block.querySelector('.block-post-slider__viewport');
		if (!viewport || viewport.swiper || typeof window.Swiper === 'undefined') {
			return;
		}

		new window.Swiper(viewport, {
			modules: [window.SwiperNavigation],
			slidesPerView: 'auto',
			spaceBetween: 12,
			centeredSlides: true,
			loop: false,
			// Dragging would fight the editor's own block selection.
			allowTouchMove: !inEditor,
			breakpoints: {
				[DESKTOP]: { spaceBetween: 24, centeredSlides: false },
			},
			navigation: {
				prevEl: block.querySelector('.block-post-slider__arrow--prev'),
				nextEl: block.querySelector('.block-post-slider__arrow--next'),
			},
		});
	};

	// In the editor the intro column belongs to React, so the arrows stay put
	// and are pinned over the room that column keeps for them.
	const pin = (block) => {
		const arrows = block.querySelector('.block-post-slider__arrows');
		const intro = introColumnFor(block);
		if (!arrows) {
			return;
		}

		const pinned = Boolean(intro) && desktop.matches;
		arrows.classList.toggle('is-pinned', pinned);
		if (!pinned || !arrows.offsetParent) {
			return;
		}

		const from = arrows.offsetParent.getBoundingClientRect();
		const to = intro.getBoundingClientRect();
		arrows.style.setProperty('--arrows-top', `${to.bottom - ARROWS_HEIGHT - from.top}px`);
		arrows.style.setProperty('--arrows-left', `${to.left - from.left}px`);
	};

	if (inEditor) {
		// ACF swaps the preview HTML on every change, and the canvas reflows as
		// the blocks around it are edited.
		let frame = 0;
		const refresh = () => {
			cancelAnimationFrame(frame);
			frame = requestAnimationFrame(() => {
				document.querySelectorAll('.block-post-slider').forEach((block) => {
					start(block);
					pin(block);
				});
			});
		};

		new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
		new ResizeObserver(refresh).observe(document.documentElement);
		return;
	}

	document.querySelectorAll('.block-post-slider').forEach((block) => {
		const arrows = block.querySelector('.block-post-slider__arrows');
		const intro = introColumnFor(block);
		start(block);

		if (arrows && intro) {
			const move = () => {
				arrows.classList.toggle('is-beside-intro', desktop.matches);
				(desktop.matches ? intro : block).append(arrows);
			};

			move();
			desktop.addEventListener('change', move);
		}
	});
})();
